// ABOUTME: Preserves a client request identifier while the same submit payload is retried.
// ABOUTME: Compares route-provided fingerprints without teaching the shared hook endpoint rules.

import {
    buildClientRequestFingerprint,
    generateClientRequestId
} from "../../../lib/clientRequestId";

export { buildClientRequestFingerprint };

export type ClientRequestIdFingerprint = (values: Compleo.IObject) => string;

type ClientRequestRef = {
    current: {
        fingerprint: string;
        clientRequestId: string;
    } | null;
};

export const withClientRequestId = (
    values: Compleo.IObject,
    ref: ClientRequestRef,
    buildFingerprint: ClientRequestIdFingerprint
) => {
    const fingerprint = buildFingerprint(values);
    if (!ref.current || ref.current.fingerprint !== fingerprint) {
        ref.current = {
            fingerprint,
            clientRequestId: generateClientRequestId()
        };
    }
    return {
        ...values,
        clientRequestId: ref.current.clientRequestId
    };
};

export const shouldRetainClientRequestId = (response: any) =>
    response?.data?.idempotencyCode === "IdempotencyPending" ||
    response?.response?.data?.idempotencyCode === "IdempotencyPending" ||
    response?.idempotencyCode === "IdempotencyPending";

export const shouldResetClientRequestId = (state: any) => {
    if (state?.status === "success") {
        return true;
    }
    if (state?.status !== "error") {
        return false;
    }
    if (shouldRetainClientRequestId(state.response)) {
        return false;
    }
    return Boolean(state.response?.response);
};
